import React, { useState } from 'react';
import { message } from 'antd';
import s from './s.module.less';
import OnboardingStepContainer from '../OnboardingStepContainer';
import ActionButtons from '../ActionButtons';
import { validateEmailFormat } from '../../../../api/auth';

interface EmailOnboardingStepProps {
    onEmailSubmit?: (email: string) => void;
    onNext?: () => void;
    onExit?: () => void;
    currentStep?: number;
    totalSteps?: number;
    initialEmail?: string;
    isCheckingEmail?: boolean;
}

export default function EmailOnboardingStep({
    onEmailSubmit,
    onNext,
    onExit,
    currentStep = 1,
    totalSteps = 7,
    initialEmail = '',
    isCheckingEmail,
}: EmailOnboardingStepProps) {
    const [email, setEmail] = useState(initialEmail);
    const [emailExists, setEmailExists] = useState(false);
    const [existingAccountMessage, setExistingAccountMessage] = useState('');

    const handleNext = async () => {
        if (!email.trim()) {
            message.error('Email is required');
            return;
        }

        // 验证邮箱格式
        if (!validateEmailFormat(email)) {
            message.error('Please enter a valid email address');
            return;
        }

        // 调用回调函数并跳转到下一步
        if (onEmailSubmit) {
            onEmailSubmit(email);
        }
        onNext?.();
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        handleNext();
    };

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newEmail = e.target.value;
        setEmail(newEmail);

        // 清除之前的账号已存在状态
        if (emailExists) {
            setEmailExists(false);
            setExistingAccountMessage('');
        }
    };

    return (
        <>
            <OnboardingStepContainer
                currentStep={currentStep}
                totalSteps={totalSteps}
                title="Enter your email to get started"
                subtitle="Please use an email address that you check regularly, as we'll send you important updates."
            >
                <form onSubmit={handleSubmit} className={s.inputSection}>
                    <div className={s.inputWrapper}>
                        <input
                            type="email"
                            value={email}
                            onChange={handleEmailChange}
                            placeholder="Enter your email"
                            className={s.emailInput}
                            required
                        />
                    </div>
                </form>
            </OnboardingStepContainer>

            {/* 账号已存在的Figma设计提示 */}
            {emailExists && existingAccountMessage && (
                <div className={s.existingAccountTip}>
                    <span className={s.checkIcon}>✓</span>
                    {existingAccountMessage}
                </div>
            )}

            <ActionButtons
                showBack={false}
                onNext={handleNext}
                nextLoading={isCheckingEmail}
                nextDisabled={!email.trim() || emailExists}
                nextLabel="Next"
                currentStep={currentStep}
            />
        </>
    );
}
